import { Injectable } from '@angular/core';
import { Iacct } from '../../../shared/models/models';
import { IacctService } from '../iacct.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class IacctsByRangeResolver implements Resolve<Iacct[]> {
    constructor(private readonly iacctService: IacctService) { }

    resolve(route: ActivatedRouteSnapshot) {
        const rangeId = route.params.rangeId;
        if (rangeId === "byNumber") {
            return this.iacctService.getIaccts();
        }
        return this.iacctService.getIaccts(rangeId);
    }
}